import { Link, Text, VStack } from '@chakra-ui/react'
import { LANGUAGES } from 'commons/constants/language'
import { TextColors } from 'commons/design-system/tokens'
import { useTranslation } from 'react-i18next'

export const ClaimTagFooter = () => {
	const { t, i18n } = useTranslation()

	const securityUrl =
		i18n.language === LANGUAGES.FRENCH
			? 'https://support.lydia.me/l/fr/article/zma7sln6cm-tout-savoir-sur-la-s-curit-de-lydia'
			: 'https://support.lydia.me/l/en/article/zma7sln6cm-what-are-the-app-s-security-measures'

	const termsUrl =
		i18n.language === LANGUAGES.FRENCH
			? 'https://support.lydia.me/l/fr/article/60t3z44b6l-documents-contractuels-de-lydia-pour-les-nouveaux-clients?hide=true'
			: 'https://lydiasocial.helpdocs.io/l/en/article/60t3z44b6l-lydia-contract-documents-for-new-customers?hide=true'

	return (
		<VStack gap={2} py={8} textAlign='center'>
			<Text
				fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
				fontSize='14px'
				fontWeight={700}
				color={TextColors.PRIMARY}
			>
				{t('claim_tag.footer_company')}
			</Text>
			<Link
				href={securityUrl}
				fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
				fontSize='14px'
				fontWeight={600}
				color={TextColors.TERTIARY}
				textDecoration='underline'
				target='_blank'
				rel='noopener noreferrer'
			>
				{t('claim_tag.footer_about_security')}
			</Link>
			<Link
				href={termsUrl}
				fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
				fontSize='14px'
				fontWeight={600}
				color={TextColors.TERTIARY}
				textDecoration='underline'
				target='_blank'
				rel='noopener noreferrer'
			>
				{t('claim_tag.footer_terms')}
			</Link>
		</VStack>
	)
}
